"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1246],{

/***/ 51246:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tracker_1 = __webpack_require__(48826);
function default_1() {
    return (app) => {
        if (app === null) {
            return (_1, _2, _3, result) => result;
        }
        return (operationKind, operationName, variables, result) => {
            try {
                app.send(tracker_1.Messages.GraphQL(operationKind, operationName, JSON.stringify(variables), JSON.stringify(result)));
            }
            finally {
                return result;
            }
        };
    };
}
exports["default"] = default_1;


/***/ })

}]);